import Brands from '../../utils/brand/brand'

/* stageFullScreenUtils variable */
export enum stageFullScreenUtils {
    MAX_INPUT_LENGTH = 17,
    MIN_INPUT_LENGTH = 5,
    HIDE_OPTIONS_LIMIT = 1,
}

// The default index must be negative, since IDs from APIs start from 0.
// This prevents items with a 0 index to be opened when closing an item.
export enum AccordionSettings {
    ACCORDION_INDEX_CLOSE_ALL_ITEMS = -1,
}

export enum QueryParams {
    PREVIEW_DATE = 'preview_date',
}

export interface AppConfig {
    featureAppId: string
    baseUrl: string | undefined
    backendUrl: string | undefined
    brand: keyof typeof Brands
    preview_date: string | undefined
    previewAPIToken: string | undefined
    trackingBrand: string | undefined
    modelFromCms: string | undefined
    layout: string | undefined
    showRFQForm: string | undefined
    autoloadRFQFormTimingDesktop: string | undefined
    autoloadRFQFormTimingMobile: string | undefined
    fivePlusLayerPath: string | undefined
}
